// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__ovKKR","csm":"Logo_csm__O965u","logo":"Logo_logo__IXIUX","logoText":"Logo_logoText__y6Y3o","collapsed":"Logo_collapsed__lDJ-w"};